import React, { Component } from 'react';
import MainSlickShowWrap from './MainSlickShowWrap';

export default class MainShowWrap extends Component {
  render() {
    const {
      planningData,
      isShowResult,
      CategoryData,
      selectedCategoryIndex,
      isReset,
      isGoToTheSamePosition,
      selectedState,
      SelectedCategoryFacets,
      gotoRow,
      setSlideArray,
      resetSelected,
      updateSamePosition,
    } = this.props;
    return (
      <div className="MainShowWrap position-relative">
        <div className="blankOver"></div>
        <div className="resetBtnWrap p-3"
          onClick={(e) => resetSelected(true)}
        >重新規劃</div>
        <MainSlickShowWrap
          isShowResult={isShowResult}
          setSlideArray={setSlideArray}
          SelectedCategoryFacets={SelectedCategoryFacets}
          CategoryData={CategoryData}
          selectedCategoryIndex={selectedCategoryIndex}
          selectedState={selectedState}
          planningData={planningData}
          isReset={isReset}
          gotoRow={gotoRow}
          isGoToTheSamePosition={isGoToTheSamePosition}
          updateSamePosition={updateSamePosition}
        />
      </div>
    )
  }
}
